"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_SUBSCRIPTION_SCHEDULED_CHANGE_TYPE = exports.USER_SUBSCRIPTION_MONTH_ADJUSTMENT_TYPE = exports.USER_SUBSCRIPTION_STATE = exports.SUBSCRIPTION_CHANGE_ERROR = exports.SUBSCRIPTION_PAUSE_ERROR = exports.SUBSCRIPTION_CANCEL_PREVIEW_ERROR = exports.SUBSCRIPTION_CANCEL_REASON_ERROR = exports.USER_SUBSCRIPTION_STATUS = exports.SUBSCRIPTION_BOOKING_ERROR = void 0;
var SUBSCRIPTION_BOOKING_ERROR;
(function (SUBSCRIPTION_BOOKING_ERROR) {
    SUBSCRIPTION_BOOKING_ERROR["USER_SUBSCRIPTION_NOT_VALID"] = "USER_SUBSCRIPTION_NOT_VALID";
    SUBSCRIPTION_BOOKING_ERROR["PAYMENT_FOR_CURRENT_PERIOD_NOT_VALID"] = "PAYMENT_FOR_CURRENT_PERIOD_NOT_VALID";
    SUBSCRIPTION_BOOKING_ERROR["EVENT_PRICE_DIFFERENT_THAN_IN_SUBSCRIPTION"] = "EVENT_PRICE_DIFFERENT_THAN_IN_SUBSCRIPTION";
    SUBSCRIPTION_BOOKING_ERROR["EXCEEDED_EVENT_BOOKED"] = "EXCEEDED_EVENT_BOOKED";
})(SUBSCRIPTION_BOOKING_ERROR || (exports.SUBSCRIPTION_BOOKING_ERROR = SUBSCRIPTION_BOOKING_ERROR = {}));
var USER_SUBSCRIPTION_STATUS;
(function (USER_SUBSCRIPTION_STATUS) {
    USER_SUBSCRIPTION_STATUS[USER_SUBSCRIPTION_STATUS["ACTIVE"] = 0] = "ACTIVE";
    USER_SUBSCRIPTION_STATUS[USER_SUBSCRIPTION_STATUS["CANCELLED"] = 1] = "CANCELLED";
    USER_SUBSCRIPTION_STATUS[USER_SUBSCRIPTION_STATUS["PENDING_PAYMENT"] = 2] = "PENDING_PAYMENT";
    USER_SUBSCRIPTION_STATUS[USER_SUBSCRIPTION_STATUS["PENDING_CHANGE"] = 3] = "PENDING_CHANGE";
})(USER_SUBSCRIPTION_STATUS || (exports.USER_SUBSCRIPTION_STATUS = USER_SUBSCRIPTION_STATUS = {}));
var SUBSCRIPTION_CANCEL_REASON_ERROR;
(function (SUBSCRIPTION_CANCEL_REASON_ERROR) {
    SUBSCRIPTION_CANCEL_REASON_ERROR["SUBSCRIPTION_NOT_CANCELLED"] = "SUBSCRIPTION_NOT_CANCELLED";
    SUBSCRIPTION_CANCEL_REASON_ERROR["CANCEL_REASON_ALREADY_RECORDED"] = "CANCEL_REASON_ALREADY_RECORDED";
    SUBSCRIPTION_CANCEL_REASON_ERROR["INVALID_CANCEL_REASON"] = "INVALID_CANCEL_REASON";
})(SUBSCRIPTION_CANCEL_REASON_ERROR || (exports.SUBSCRIPTION_CANCEL_REASON_ERROR = SUBSCRIPTION_CANCEL_REASON_ERROR = {}));
var SUBSCRIPTION_CANCEL_PREVIEW_ERROR;
(function (SUBSCRIPTION_CANCEL_PREVIEW_ERROR) {
    SUBSCRIPTION_CANCEL_PREVIEW_ERROR["SUBSCRIPTION_ALREADY_CANCELLED"] = "SUBSCRIPTION_ALREADY_CANCELLED";
})(SUBSCRIPTION_CANCEL_PREVIEW_ERROR || (exports.SUBSCRIPTION_CANCEL_PREVIEW_ERROR = SUBSCRIPTION_CANCEL_PREVIEW_ERROR = {}));
var SUBSCRIPTION_PAUSE_ERROR;
(function (SUBSCRIPTION_PAUSE_ERROR) {
    SUBSCRIPTION_PAUSE_ERROR["SUBSCRIPTION_NOT_ACTIVE"] = "SUBSCRIPTION_NOT_ACTIVE";
    SUBSCRIPTION_PAUSE_ERROR["ALREADY_PAUSED_FOR_PERIOD"] = "ALREADY_PAUSED_FOR_PERIOD";
    SUBSCRIPTION_PAUSE_ERROR["EVENT_ALREADY_BOOKED_FOR_PERIOD"] = "EVENT_ALREADY_BOOKED_FOR_PERIOD";
    SUBSCRIPTION_PAUSE_ERROR["RENEWAL_PAYMENT_PENDING"] = "RENEWAL_PAYMENT_PENDING";
    SUBSCRIPTION_PAUSE_ERROR["PLAN_CHANGE_SCHEDULED"] = "PLAN_CHANGE_SCHEDULED";
})(SUBSCRIPTION_PAUSE_ERROR || (exports.SUBSCRIPTION_PAUSE_ERROR = SUBSCRIPTION_PAUSE_ERROR = {}));
var SUBSCRIPTION_CHANGE_ERROR;
(function (SUBSCRIPTION_CHANGE_ERROR) {
    SUBSCRIPTION_CHANGE_ERROR["SUBSCRIPTION_DOES_NOT_EXIST"] = "SUBSCRIPTION_DOES_NOT_EXIST";
    SUBSCRIPTION_CHANGE_ERROR["SUBSCRIPTION_NOT_ACTIVE"] = "SUBSCRIPTION_NOT_ACTIVE";
    SUBSCRIPTION_CHANGE_ERROR["SERVICE_NOT_SUBSCRIBABLE"] = "SERVICE_NOT_SUBSCRIBABLE";
    SUBSCRIPTION_CHANGE_ERROR["SUBSCRIPTION_PLAN_DOES_NOT_EXIST"] = "SUBSCRIPTION_PLAN_DOES_NOT_EXIST";
    SUBSCRIPTION_CHANGE_ERROR["SUBSCRIPTION_PLAN_SAME_AS_CURRENT"] = "SUBSCRIPTION_PLAN_SAME_AS_CURRENT";
    SUBSCRIPTION_CHANGE_ERROR["SUBSCRIPTION_STARTING_NEXT_MONTH_EXISTS"] = "SUBSCRIPTION_STARTING_NEXT_MONTH_EXISTS";
    // seamless (AID-267) change pre-check: a future month already has more booked/scheduled events
    // than the new plan would grant
    SUBSCRIPTION_CHANGE_ERROR["BOOKED_EVENT_COUNT_EXCEEDED"] = "BOOKED_EVENT_COUNT_EXCEEDED";
    // seamless change requires a real Stripe subscription on the current row
    SUBSCRIPTION_CHANGE_ERROR["SEAMLESS_CHANGE_UNAVAILABLE"] = "SEAMLESS_CHANGE_UNAVAILABLE";
    SUBSCRIPTION_CHANGE_ERROR["SUBSCRIPTION_PAUSED"] = "SUBSCRIPTION_PAUSED";
})(SUBSCRIPTION_CHANGE_ERROR || (exports.SUBSCRIPTION_CHANGE_ERROR = SUBSCRIPTION_CHANGE_ERROR = {}));
/**
 * String state for GET /userSubscription (AID-427). A single, consistent encoding of the
 * user's subscription state, describing *this calendar month* only - anything that changes
 * starting next month (a plan change or a not-yet-started pause) is carried separately in
 * `scheduledChange`, not folded in here. PAUSED has no direct DB column (it's derived: an
 * ACTIVE row with a pause whose periodFrom has already arrived), and NONE means the user
 * currently has no subscription.
 *
 * No PENDING_CHANGE member: a plan change in progress (legacy PENDING_PAYMENT successor, or a
 * PENDING_CHANGE seamless successor - AID-267) never becomes `status` itself - the old row stays
 * ACTIVE this month regardless, and the successor surfaces via `scheduledChange` instead.
 *
 * ENDING: a cancellation takes effect at the end of the calendar month (the user keeps access -
 * bookable events, usage - until then), not immediately. A cancelled subscription is still a
 * candidate while `validTo` hasn't passed yet; once it has, the user genuinely has NONE.
 */
var USER_SUBSCRIPTION_STATE;
(function (USER_SUBSCRIPTION_STATE) {
    USER_SUBSCRIPTION_STATE["ACTIVE"] = "ACTIVE";
    USER_SUBSCRIPTION_STATE["PENDING_PAYMENT"] = "PENDING_PAYMENT";
    USER_SUBSCRIPTION_STATE["PAUSED"] = "PAUSED";
    USER_SUBSCRIPTION_STATE["ENDING"] = "ENDING";
    USER_SUBSCRIPTION_STATE["NONE"] = "NONE";
})(USER_SUBSCRIPTION_STATE || (exports.USER_SUBSCRIPTION_STATE = USER_SUBSCRIPTION_STATE = {}));
/**
 * What changed a given month's grant away from the plan default in the GET /userSubscription
 * usage breakdown (`pastMonths`/`currentMonth`/`upcomingMonths`).
 */
var USER_SUBSCRIPTION_MONTH_ADJUSTMENT_TYPE;
(function (USER_SUBSCRIPTION_MONTH_ADJUSTMENT_TYPE) {
    USER_SUBSCRIPTION_MONTH_ADJUSTMENT_TYPE["PAUSE"] = "PAUSE";
    // the subscription itself has never been paid - nothing has actually been granted yet
    USER_SUBSCRIPTION_MONTH_ADJUSTMENT_TYPE["PENDING_PAYMENT"] = "PENDING_PAYMENT";
    // an otherwise-ACTIVE subscription whose current month's renewal hasn't cleared yet (Smart
    // Retries in progress, a webhook that hasn't landed) - real booking is blocked the same way
    USER_SUBSCRIPTION_MONTH_ADJUSTMENT_TYPE["RENEWAL_PAYMENT_PENDING"] = "RENEWAL_PAYMENT_PENDING";
    // a seamless plan change (AID-267) is scheduled to take effect this month or later - the grant
    // shown is still the current plan's (the successor isn't active yet), but this month belongs to
    // the pending change, same as PAUSE already marks a not-yet-started pause's affected month
    USER_SUBSCRIPTION_MONTH_ADJUSTMENT_TYPE["PLAN_CHANGE"] = "PLAN_CHANGE";
})(USER_SUBSCRIPTION_MONTH_ADJUSTMENT_TYPE || (exports.USER_SUBSCRIPTION_MONTH_ADJUSTMENT_TYPE = USER_SUBSCRIPTION_MONTH_ADJUSTMENT_TYPE = {}));
/**
 * What's scheduled to take effect starting next month in GET /userSubscription, when it
 * differs from what's true this month (`status`/`subscription`/`usage` describe now only).
 */
var USER_SUBSCRIPTION_SCHEDULED_CHANGE_TYPE;
(function (USER_SUBSCRIPTION_SCHEDULED_CHANGE_TYPE) {
    USER_SUBSCRIPTION_SCHEDULED_CHANGE_TYPE["PLAN_CHANGE"] = "PLAN_CHANGE";
    USER_SUBSCRIPTION_SCHEDULED_CHANGE_TYPE["PAUSE"] = "PAUSE";
})(USER_SUBSCRIPTION_SCHEDULED_CHANGE_TYPE || (exports.USER_SUBSCRIPTION_SCHEDULED_CHANGE_TYPE = USER_SUBSCRIPTION_SCHEDULED_CHANGE_TYPE = {}));
